module.exports = __webpack_public_path__ + "static/media/A+ label.57f94592.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/A+ label.png
// module id = 978
// module chunks = 0